import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalTitle from "react-bootstrap/ModalTitle";
import ModalBody from "react-bootstrap/ModalBody";
import ModalFooter from "react-bootstrap/ModalFooter";
import { Formik, Form } from "formik";
import { Select } from "view/component/FormFormik";
import { showLoading, toast } from "view/component/Alert";
import apiService from "apiService";
const ModalUpdateClinic = (props) => {
  const [visit, setVisit] = useState({
    id: props.data.id,
    clinic_id: props.data.clinic_id,
  });
  const formClinic = (data) => {
    let option = [];
    data.map((a) => {
      if (a.clinic.child.length > 0) {
        a.clinic.child.map((b) => {
          option.push({ id: b.clinic_id, name: b.name });
        });
      } else {
        option.push({ id: a.clinic.id, name: a.clinic.name });
      }
    });
    return option;
  };

  const updateVisit = async () => {
    showLoading("Sedang Mengubah Data");
    if (visit.id > 0) {
      let res = await apiService.put(`registration/change/visit`, {
        visit,
      });
      if (res.code == 200) {
        updateQueue();
        toast({ status: "success", text: "date diubah" });
        props.onHide();
      } else {
        toast({ status: "error", text: "Gagal Mengubah Data" });
      }
    } else {
      toast({ status: "error", text: "data belum dipilih" });
    }
  };

  const updateQueue = async () => {
    let regClinic = props.refData?.refClinic?.find(
      (a) => a.clinic_id == visit.clinic_id
    );
    let res = await apiService.put(`/apm/queues/update_clinic`, {
      id: props.data.queue?.id,
      clinic_id: regClinic.id ?? visit.clinic_id,
    });
  };
  console.log(props.refData);
  console.log(visit);

  return (
    <div>
      <Modal {...props} aria-labelledby="modal-user">
        <ModalHeader closeButton>
          <ModalTitle>
            <h3>Edit Data Klinik</h3>
          </ModalTitle>
        </ModalHeader>
        <Formik
          enableReinitialize
          initialValues={{
            ...visit,
          }}
          // validationSchema={SignupSchema}
          onSubmit={(values) => {
            updateVisit();
          }}
        >
          {({ errors, touched }) => (
            <Form className="col-md-12">
              <ModalBody>
                <Select
                  name="clinic"
                  onChange={(e) =>
                    setVisit({ ...visit, clinic_id: e.target.value })
                  }
                  value={visit.clinic_id}
                  errors={errors}
                  touched={touched}
                  icon="ni ni-circle-08"
                  label="Klinik"
                  option={
                    props.refData?.refClinic?.length > 0
                      ? formClinic(props.refData.refClinic)
                      : []
                  }
                />
              </ModalBody>
              <ModalFooter>
                <button
                  type="button"
                  onClick={() => {
                    props.onHide();
                  }}
                  className="btn btn-secondary"
                >
                  Batal
                </button>
                <button type="submit" className="btn btn-primary">
                  Simpan Data
                </button>
              </ModalFooter>
            </Form>
          )}
        </Formik>
      </Modal>
    </div>
  );
};

export default ModalUpdateClinic;
